import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import RadioButtonWithText from "../../../../components/Inputs/RadioButtonWithText";
import { SpacerContainer } from "../../../../components/styledComponents/SpacerContainer";
import {
  BemessungenMikropfaehle,
  selectBemessungenMikropfaehle,
} from "../../../../store/slices/bemessungenMikropfaehleSlice";
import {
  selectFrontendZustand,
  setKnickenTypeRadio,
} from "../../../../store/slices/frontendZustandSlice";
import DinEN1993 from "./dinEN1993/DinEN1993";
import KnickenOfner from "./KnickenOfner/KnickenOfner";

export default function Knicken() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const { knickenTypeRadio } = useSelector(selectFrontendZustand);
  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);

  const onChangeKnickenType = (e) => {
    dispatch(setKnickenTypeRadio(e.target.value));
  };

  return (
    <SpacerContainer>
      <div className="row">
        <h1>{t("inner.buckling.headline")}</h1>
      </div>
      <div onChange={(e) => onChangeKnickenType(e)}>
        <Row>
          <Col>
            <RadioButtonWithText
              name="knickenType"
              value="1"
              checked={knickenTypeRadio == 1}
              text={t("inner.buckling.buttonOfner")}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <RadioButtonWithText
              name="knickenType"
              value="0"
              checked={knickenTypeRadio == 0}
              text={
                bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7
                  ? t("inner.buckling.buttonDinEN1993_ec7")
                  : t("inner.buckling.buttonDinEN1993")
              }
            />
          </Col>
        </Row>
      </div>

      {knickenTypeRadio == 0 ? <DinEN1993 /> : null}
      {knickenTypeRadio == 1 ? <KnickenOfner /> : null}
    </SpacerContainer>
  );
}
